import { Icons } from '@commenda/kakashi';

const TaskCard = ({
  title,
  description,
  renderButton,
  isTaskCompleted,
}: {
  title: string;
  description: string;
  renderButton: () => React.ReactNode;
  isTaskCompleted: boolean;
}) => {
  return (
    <div className="flex items-center justify-between border rounded-2xl px-4 py-3 bg-bg-secondary gap-4 w-[500px] border-border-primary">
      <div className="flex gap-2 items-start min-w-0">
        <div className="flex items-center gap-1 mt-0.5">
          {isTaskCompleted ? (
            <div className="w-5 h-5 p-1 rounded-full flex items-center justify-center bg-success-100">
              <Icons.Check className="size-4 text-white" />
            </div>
          ) : (
            <div className="w-5 h-5 p-1 rounded-full flex items-center justify-center border border-border-primary" />
          )}
        </div>
        <div className="flex flex-col gap-0.5">
          <h3 className="txt-medium-medium text-text-primary">
            {title}
          </h3>
          <p className="txt-small-regular text-text-secondary">{description}</p>
        </div>
      </div>
      <div className="flex-shrink-0">
        {renderButton && renderButton()}
      </div>
    </div>
  );
};

export default TaskCard;
